module.exports = __webpack_public_path__ + "media/images/distilation-desktop-xl-c6e2fa36c1a417379385cde7294cea82.jpg";